module.exports = __webpack_public_path__ + "img/gen1.67e2f379.jpg";